import { render, staticRenderFns } from "./InCallOrders.vue?vue&type=template&id=50b8e1f6&scoped=true&"
import script from "./InCallOrders.vue?vue&type=script&lang=js&"
export * from "./InCallOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b8e1f6",
  null
  
)

export default component.exports